import { useEffect } from "react";
// import { useState } from "react"; // Currently unused

// The hook is responsible for handling scroll events and calling onScrollChange
const useScrollTracking = (onScrollChange) => {
  useEffect(() => {
    // Initialize last scroll position
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      // Get the current scroll position
      const currentY = window.scrollY;

      // Calculate the scroll delta
      const delta = Math.abs(currentY - lastScrollY);

      // Determine scroll direction
      const direction = currentY > lastScrollY ? "down" : "up";

      // If the delta is large enough, trigger onScrollChange
      if (delta > 10) {
        onScrollChange(direction, delta); // Pass direction and delta to parent
      }

      // Update last scroll position
      lastScrollY = currentY;
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [onScrollChange]);
};

export default useScrollTracking;
